export default function isShippingStateAvailable(countryCode) {
	return ['US', 'CA'].includes(countryCode);
}



// WEBPACK FOOTER //
// ./src/core/utils/isShippingStateAvailable.js